import { Box } from '@common-fe/common-fe';
import styled from 'styled-components';

export const StyledGroupCard = styled(Box)<{ $expanded?: boolean }>`
  border-radius: 8px;
  border: ${({ theme, $expanded }) =>
    $expanded ? `2px solid ${theme.colors.border1}` : `1px solid ${theme.colors.border2}`};
  background: ${({ theme }) => theme.colors.canvas};
  overflow: hidden;
  padding-bottom: ${({ theme }) => theme.spacings.xs};
`;

export const StyledCheckboxNoMargin = styled(Box)`
  & [class*="LabelBox"],
  & label {
    margin: 0 !important;
    padding: 0 !important;
  }
`;

export const StyledChevronButton = styled(Box)`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.border2};
  cursor: pointer;
  align-self: stretch;
  min-width: 40px;
`;

export const StyledSmallCheckbox = styled(Box)`
  & [class*="CheckmarkWrapper"] {
    width: 16px;
    height: 16px;
    min-width: 16px;
    border-radius: 4px;
  }
`;


